if (!customElements.get('deployer-pack-builder')) {
  customElements.define(
    'deployer-pack-builder',
    class PackBuilder extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const addButton = event.target.closest('.quick-add-pack-builder--add');
          if (addButton) {
            this.dispatchVariantData(event, addButton);
          }
        });

        this.addEventListener('change', (event) => {
          const select = event.target.closest('.pack-maker-card__variant-select');
          if (!select) return;
          const card = select.closest('.card__content');
          const hiddenInput = card ? card.querySelector('input[name="id"]') : null;
          if (hiddenInput) hiddenInput.value = select.value;
        });
      }

      async dispatchVariantData(event) {
        event.preventDefault();
        const card = event.target.closest('.card__content');
        if (!card) return;

        const idInput = card.querySelector('input[name="id"]');
        if (!idInput) return;

        const variantId = idInput.value;
        const handle = idInput.dataset.handle;
        const variantData = await this.getVariantData(handle, variantId);
        if (!variantData) return;

        document.dispatchEvent(
          new CustomEvent('pack-builder-selected-variants-changed', {
            detail: variantData,
          })
        );
      }

      async getVariantData(productHandle, variantId) {
        try {
          const response = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);
          const data = await response.json();
          const parsedVariantId = parseInt(variantId, 10);
          const variant = data.variants.find((item) => item.id === parsedVariantId);
          if (!variant) return null;

          const sellingPlansById = {};
          (data.selling_plan_groups || []).forEach((group) => {
            (group.selling_plans || []).forEach((plan) => {
              if (plan && plan.id) {
                sellingPlansById[String(plan.id)] = plan.name || '';
              }
            });
          });
          const allocations = Array.isArray(variant.selling_plan_allocations) ? variant.selling_plan_allocations : [];
          const seenPlanIds = {};
          variant.pack_builder_selling_plans = allocations
            .map((allocation, index) => {
              const planId = allocation && allocation.selling_plan_id ? allocation.selling_plan_id : null;
              if (!planId || seenPlanIds[String(planId)]) return null;
              seenPlanIds[String(planId)] = true;
              return {
                id: planId,
                name: sellingPlansById[String(planId)] || `Livraison ${index + 1}`,
              };
            })
            .filter(Boolean);

          if (data.variants.length === 1) {
            variant.featured_image = { src: data.featured_image, alt: data.title };
            variant.title = data.title;
          }
          if (!variant.featured_image && data.featured_image) {
            variant.featured_image = { src: data.featured_image, alt: data.title };
          }
          return variant;
        } catch (error) {
          console.error('Pack Builder: erreur récupération variant', error);
          return null;
        }
      }
    }
  );
}

if (!customElements.get('deployer-pack-builder-progress-bar')) {
  customElements.define(
    'deployer-pack-builder-progress-bar',
    class DeployerPackBuilderProgressBar extends HTMLElement {
      constructor() {
        super();
        this.progressType = this.dataset.progressType;
        this.thresholds = [];
        this.discounts = [];

        if (this.progressType === 'progress_step_price') {
          this.topStepsLabels = this.querySelectorAll('.pack-builder-progress-bar--top-item');
          this.steps = this.querySelectorAll('.pack-builder-progress-bar--item');
          this.steps.forEach((step) => {
            this.thresholds.push(parseInt(step.dataset.threshold * 100, 10));
            this.discounts.push(parseInt(step.dataset.discount * 100, 10));
          });
        } else {
          this.steps = this.querySelectorAll('.pack-builder-progress-bar--product--container');
          this.steps.forEach((step) => {
            this.thresholds.push(parseInt(step.dataset.threshold, 10));
            this.discounts.push(parseInt(step.dataset.discount || 0, 10));
          });
          this.progressBarsContainers = this.querySelectorAll('.pack-builder-progress-bar--product--container');
        }
      }

      connectedCallback() {
        document.addEventListener('pack-builder-total-price-changed', (e) => {
          if (this.progressType === 'progress_step_price') {
            this.updateProgressBar(e.detail.totalPrice);
            this.updateProgressText(e.detail);
          } else {
            this.updateProductProgressBar(e.detail);
          }
        });
      }

      updateProductProgressBar(data) {
        if (!this.progressBarsContainers) return;
        this.progressBarsContainers.forEach((progressbar, index) => {
          const threshold = parseInt(progressbar.dataset.threshold || index + 1, 10);
          if ((data.productsCount || 0) >= threshold) {
            progressbar.classList.add('pack-builder-progress-bar--product--container--completed');
          } else {
            progressbar.classList.remove('pack-builder-progress-bar--product--container--completed');
          }
        });
      }

      updateProgressBar(totalPrice) {
        const progressBarInner = this.querySelector('.pack-builder-progress-bar--inner');
        if (!progressBarInner || !this.steps.length) return;

        let previousLeft = 0;
        let previousThreshold = 0;

        this.steps.forEach((step, index) => {
          step.classList.remove('completed');
          if (this.topStepsLabels && this.topStepsLabels[index]) {
            this.topStepsLabels[index].classList.remove('completed');
          }
        });

        for (let index = 0; index < this.steps.length; index += 1) {
          const step = this.steps[index];
          const topStepLabel = this.topStepsLabels ? this.topStepsLabels[index] : null;
          const stepLeft = parseInt(step.style.left, 10);
          const threshold = this.thresholds[index];

          if (totalPrice < threshold) {
            const percentageBetweenSteps = (totalPrice - previousThreshold) / (threshold - previousThreshold);
            const relativeLeft = previousLeft + percentageBetweenSteps * (stepLeft - previousLeft);
            progressBarInner.style.width = `${Math.min(relativeLeft, stepLeft)}%`;
            return;
          }

          previousLeft = stepLeft;
          previousThreshold = threshold;
          progressBarInner.style.width = `${stepLeft}%`;
          step.classList.add('completed');
          if (topStepLabel) topStepLabel.classList.add('completed');
        }

        if (totalPrice >= this.thresholds[this.thresholds.length - 1]) {
          progressBarInner.style.width = '100%';
        }
      }

      updateProgressText(data) {
        const amountNeededSpan = this.querySelector('.pack-builder-summary--text-amount-needed');
        const discountSpan = this.querySelector('.pack-builder-summary--text-discount');
        if (!amountNeededSpan || !discountSpan) return;

        if (data.nextThresholdIndex < this.thresholds.length) {
          const amountNeeded = this.thresholds[data.nextThresholdIndex] - data.totalPrice;
          amountNeededSpan.innerHTML = formatPrice(amountNeeded);
          discountSpan.innerHTML = formatPrice(this.discounts[data.nextThresholdIndex]);
        }

        const success = this.querySelector('.pack-builder-progress-bar--text--success');
        const normal = this.querySelector('.pack-builder-progress-bar--text');
        if (!success || !normal) return;

        if (data.nextThresholdIndex === this.thresholds.length) {
          success.classList.remove('hidden');
          normal.classList.add('hidden');
        } else {
          success.classList.add('hidden');
          normal.classList.remove('hidden');
        }
      }
    }
  );
}

if (!customElements.get('pack-builder-summary')) {
  customElements.define(
    'pack-builder-summary',
    class PackBuilderSummary extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector('details.pack-builder-summary--details');
        if (window.matchMedia('(min-width: 1024px)').matches && this.details) {
          this.details.setAttribute('open', 'true');
        }

        this.summaryProductList = this.querySelector('.pack-builder-summary--product-list');
        this.productsCount = parseInt(this.dataset.productsCount || '0', 10);
        this.minProduct = parseInt(this.dataset.minProduct || '1', 10);
        this.form = this.querySelector('form');
        this.thresholds = [];
        this.discounts = [];
        this.totalPrice = 0;
        const defaultPurchaseType = this.dataset.defaultPurchaseType;
        this.purchaseType = defaultPurchaseType === 'one-time' ? 'one-time' : 'subscription';
        const parsedDiscountPercent = parseInt(this.dataset.subscriptionDiscountPercent || '10', 10);
        this.subscriptionDiscountPercent = Number.isNaN(parsedDiscountPercent) ? 10 : parsedDiscountPercent;
        this.mobileToggle = this.querySelector('.pack-builder-summary__mobile-toggle');
        this.mobileClose = this.querySelector('.pack-builder-summary__mobile-close');
        this.mobileProducts = this.querySelector('[data-mobile-products]');
        this.addButtonPrice = this.querySelector('.pack-builder-summary--add-price');
        this.mobilePreviewSlots = 6;

        const progressBar = this.closest('.deployer-pack-builder-section').querySelector('deployer-pack-builder-progress-bar');
        this.progressType = progressBar ? progressBar.dataset.progressType : 'progress_step_products';

        if (this.progressType === 'progress_step_price') {
          this.steps = this.closest('.deployer-pack-builder-section').querySelectorAll('.pack-builder-progress-bar--item');
          this.steps.forEach((step) => {
            this.thresholds.push(parseInt(step.dataset.threshold * 100, 10));
            this.discounts.push(parseInt(step.dataset.discount * 100, 10));
          });
        } else {
          this.steps = this.closest('.deployer-pack-builder-section').querySelectorAll('.pack-builder-progress-bar--product--container');
          this.steps.forEach((step) => {
            this.thresholds.push(parseInt(step.dataset.threshold, 10));
            this.discounts.push(parseInt(step.dataset.discount || 0, 10));
          });
        }
      }

      connectedCallback() {
        document.addEventListener('pack-builder-selected-variants-changed', (e) => {
          this.handleSelectedVariant(e.detail);
          this.increaseProductCount();
        });

        document.addEventListener('pack-builder-total-price-changed', (e) => {
          this.updatePrices(e.detail);
          this.updateSummaryText(e.detail);
        });

        if (this.form) {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
        const addButton = this.querySelector('.pack-builder-summary--add');
        if (addButton) {
          addButton.addEventListener('click', this.handleSubmit.bind(this));
        }
        this.querySelectorAll('[data-purchase-type]').forEach((button) => {
          button.addEventListener('click', () => this.handlePurchaseTypeChange(button.dataset.purchaseType));
        });
        this.addEventListener('change', this.handleSellingPlanSelectChange.bind(this));
        if (this.mobileToggle) {
          this.mobileToggle.addEventListener('click', this.toggleMobileSummary.bind(this));
        }
        if (this.mobileClose) {
          this.mobileClose.addEventListener('click', this.closeMobileSummary.bind(this));
        }
        window.addEventListener('resize', this.handleViewportChange.bind(this));

        this.restoreSelectedVariantsFromSessionStorage();
        this.updateSellingPlanInputsState();
        this.syncCrossSellStates();
        this.renderMobilePreview();
        this.handleViewportChange();
        this.updatePurchaseTypeClass();
      }

      handlePurchaseTypeChange(type) {
        if (!type || (type !== 'subscription' && type !== 'one-time')) return;
        this.purchaseType = type;
        this.querySelectorAll('[data-purchase-type]').forEach((button) => {
          button.classList.toggle('pack-builder-summary__purchase-btn--active', button.dataset.purchaseType === type);
        });
        this.updatePurchaseTypeClass();
        this.updateSellingPlanInputsState();
        this.refreshItemPrices();
        this.getTotalPrice();
      }

      updatePurchaseTypeClass() {
        this.classList.toggle('pack-builder-summary--purchase-subscription', this.purchaseType === 'subscription');
        this.classList.toggle('pack-builder-summary--purchase-one-time', this.purchaseType === 'one-time');
      }

      handleSellingPlanSelectChange(event) {
        const select = event.target.closest('.pack-builder-summary--selling-plan-select');
        if (!select) return;
        const item = select.closest('.pack-builder-summary--product-list--item');
        if (!item) return;
        item.dataset.sellingPlanId = select.value || '';
        this.syncVariantSellingPlanToSessionStorage(item.dataset.id, item.dataset.sellingPlanId);
      }

      async handleSubmit(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        const items = Array.from(this.querySelectorAll('.pack-builder-summary--product-list--item'))
          .map((item) => {
            const payloadItem = {
              id: parseInt(item.dataset.id, 10),
              quantity: Math.max(1, parseInt(item.dataset.quantity, 10) || 1),
            };
            if (this.purchaseType === 'subscription' && item.dataset.sellingPlanId) {
              payloadItem.selling_plan = parseInt(item.dataset.sellingPlanId, 10);
            }
            return payloadItem;
          })
          .filter((item) => item.id > 0);

        if (!items.length) return;

        const button = this.querySelector('.pack-builder-summary--add');
        if (button) button.disabled = true;

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          console.error('Pack builder: erreur ajout panier', error);
        } finally {
          if (button) button.disabled = false;
        }
      }

      handleSelectedVariant(selectedVariant) {
        this.createVariantItem(selectedVariant);
        this.updateFormInputs();
        this.saveSelectedVariantsToSessionStorage(selectedVariant);
      }

      saveSelectedVariantsToSessionStorage(selectedVariant) {
        const savedVariants = JSON.parse(sessionStorage.getItem('packBuilderSelectedVariants') || '[]');
        const existingVariantIndex = savedVariants.findIndex((variant) => variant.id === selectedVariant.id);
        if (existingVariantIndex === -1) {
          selectedVariant.quantity = 1;
          savedVariants.push(selectedVariant);
        } else if (selectedVariant.selected_selling_plan_id) {
          savedVariants[existingVariantIndex].selected_selling_plan_id = selectedVariant.selected_selling_plan_id;
        }
        sessionStorage.setItem('packBuilderSelectedVariants', JSON.stringify(savedVariants));
      }

      restoreSelectedVariantsFromSessionStorage() {
        const savedVariants = JSON.parse(sessionStorage.getItem('packBuilderSelectedVariants') || '[]');
        savedVariants.forEach((selectedVariant) => {
          for (let i = 0; i < selectedVariant.quantity; i += 1) {
            document.dispatchEvent(
              new CustomEvent('pack-builder-selected-variants-changed', {
                detail: selectedVariant,
              })
            );
          }
        });
      }

      createVariantItem(variant, crosssell = null) {
        const existingItem = this.summaryProductList.querySelector(`[data-id="${variant.id}"]`);
        const sellingPlans = this.getVariantSellingPlans(variant);
        const defaultSellingPlanId = this.resolveDefaultSellingPlanId(sellingPlans, variant.selected_selling_plan_id);

        if (existingItem) {
          const quantity = parseInt(existingItem.dataset.quantity, 10) || 1;
          const nextQty = quantity + 1;
          existingItem.dataset.quantity = nextQty;
          if (!existingItem.dataset.sellingPlanId && defaultSellingPlanId) {
            existingItem.dataset.sellingPlanId = defaultSellingPlanId;
          }
          const qtyBadge = existingItem.querySelector('.pack-builder-summary--product-list--item--quantity');
          const qtyValue = existingItem.querySelector('.pack-builder-summary--product-list--item--quantity-value');
          if (qtyBadge) qtyBadge.innerHTML = nextQty;
          if (qtyValue) qtyValue.innerHTML = nextQty;
          this.updateSummaryItemPrice(existingItem);
          this.syncVariantQuantityToSessionStorage(variant.id, nextQty);
          this.syncCrossSellStates();
          this.renderMobilePreview();
        } else {
          const item = document.createElement('li');
          item.dataset.id = variant.id;
          item.dataset.price = variant.price;
          item.dataset.quantity = 1;
          item.dataset.sellingPlanId = defaultSellingPlanId || '';
          item.classList.add('pack-builder-summary--product-list--item');

          const title = variant.product_title || variant.name || variant.title || '';
          const imageSrc = variant.featured_image && variant.featured_image.src ? variant.featured_image.src : '';

          item.innerHTML = `
            <div class="pack-builder-summary--product-list--item--content">
              <div class="pack-builder-summary--product-list--item--image">
                <span class="pack-builder-summary--product-list--item--quantity">1</span>
                ${imageSrc ? `<img src="${imageSrc}" alt="${title}" width="60" height="60" />` : ''}
              </div>
              <div class="pack-builder-summary--product-list--item--main">
                <div class="pack-builder-summary--product-list--item--top">
                  <div class="pack-builder-summary--product-list--item--title">${title}</div>
                  <div class="pack-builder-summary--product-list--item--prices">
                    <s class="pack-builder-summary--product-list--item--compare-at-price hidden"></s>
                    <span class="pack-builder-summary--product-list--item--price">${formatPrice(this.getDisplayAmount(variant.price))}</span>
                    <span class="pack-builder-summary--product-list--item--discount-note hidden">${this.subscriptionDiscountPercent}% de reduction</span>
                  </div>
                </div>
                <div class="deployer-quantity pack-builder-summary--product-list--item--quantity-selector">
                  <button type="button" data-action="decrease" aria-label="Diminuer">-</button>
                  <span class="pack-builder-summary--product-list--item--quantity-value">1</span>
                  <button type="button" data-action="increase" aria-label="Augmenter">+</button>
                </div>
              </div>
            </div>
            ${
              sellingPlans.length
                ? `
                  <div class="pack-builder-summary--selling-plan ${this.purchaseType === 'subscription' ? '' : 'hidden'}">
                    <div class="pack-builder-summary--selling-plan-label">Fréquence de livraison</div>
                    <select class="deployer-select deployer-select--small pack-builder-summary--selling-plan-select">
                      ${sellingPlans
                        .map(
                          (plan) =>
                            `<option value="${plan.id}" ${String(plan.id) === String(defaultSellingPlanId) ? 'selected' : ''}>${this.escapeHtml(plan.name)}</option>`
                        )
                        .join('')}
                    </select>
                  </div>
                `
                : ''
            }
          `;

          this.summaryProductList.appendChild(item);
          this.updateSummaryItemPrice(item);
          this.updateSellingPlanInputsState();
          const increaseButton = item.querySelector('[data-action="increase"]');
          const decreaseButton = item.querySelector('[data-action="decrease"]');
          if (increaseButton) {
            increaseButton.addEventListener('click', () => this.increaseItemQuantity(variant.id));
          }
          if (decreaseButton) {
            decreaseButton.addEventListener('click', () => this.decreaseItemQuantity(variant.id, crosssell));
          }
          this.syncCrossSellStates();
          this.renderMobilePreview();
        }
      }

      removeItem(variantId) {
        const item = this.summaryProductList.querySelector(`.pack-builder-summary--product-list--item[data-id="${variantId}"]`);
        if (!item) return;
        this.decreaseProductCount(item.dataset.quantity || 1);
        item.remove();
        this.syncVariantQuantityToSessionStorage(variantId, 0);
        this.getTotalPrice();
        this.syncCrossSellStates();
        this.renderMobilePreview();
      }

      decreaseProductCount(value) {
        this.productsCount = parseInt(this.productsCount, 10) - parseInt(value, 10);
        this.querySelector('.pack-builder-summary--title-product-count').innerHTML = this.productsCount;
        this.handleSummaryTextState();
        this.handleButtonState();
        this.handleTotalsState(this.productsCount);
      }

      increaseProductCount() {
        this.productsCount = parseInt(this.productsCount, 10) + 1;
        this.querySelector('.pack-builder-summary--title-product-count').innerHTML = this.productsCount;
        this.handleSummaryTextState();
        this.handleButtonState();
        this.handleTotalsState(this.productsCount);
        this.getTotalPrice();
      }

      handleSummaryTextState() {
        if (this.productsCount >= this.minProduct) {
          this.querySelector('.pack-builder-summary--text').classList.remove('hidden');
          this.querySelector('.pack-builder-summary--disabled-text').classList.add('hidden');
        } else {
          const productsNeededNode = this.querySelector('.pack-builder-summary--disabled-text-products-needed');
          if (productsNeededNode) {
            productsNeededNode.innerHTML = this.minProduct - this.productsCount;
          }
          this.querySelector('.pack-builder-summary--text').classList.add('hidden');
          this.querySelector('.pack-builder-summary--disabled-text').classList.remove('hidden');
        }
      }

      handleButtonState() {
        if (this.productsCount >= this.minProduct) {
          this.querySelector('.pack-builder-summary--add').disabled = false;
          this.querySelector('.pack-builder-summary--add-text').classList.remove('hidden');
          this.querySelector('.pack-builder-summary--add-text--disabled').classList.add('hidden');
        } else {
          this.querySelector('.pack-builder-summary--add').disabled = true;
          this.querySelector('.pack-builder-summary--add-text').classList.add('hidden');
          this.querySelector('.pack-builder-summary--add-text--disabled').classList.remove('hidden');
        }
      }

      handleTotalsState(productCount) {
        if (productCount > 0) {
          this.querySelector('.pack-builder-summary--totals').classList.remove('hidden');
        } else {
          this.querySelector('.pack-builder-summary--totals').classList.add('hidden');
        }
      }

      getTotalPrice() {
        const items = Array.from(this.querySelectorAll('.pack-builder-summary--product-list--item'));
        const baseTotalPrice = items.reduce(
          (total, item) => total + parseFloat(item.dataset.price) * parseInt(item.dataset.quantity, 10),
          0
        );
        this.totalPrice = baseTotalPrice;
        const effectiveTotalPrice = this.getDisplayAmount(baseTotalPrice);

        document.dispatchEvent(
          new CustomEvent('pack-builder-total-price-changed', {
            detail: {
              totalPrice: this.totalPrice,
              effectiveTotalPrice: effectiveTotalPrice,
              productsCount: this.productsCount,
              thresholdIndex: this.getThresholdIndex(this.totalPrice),
              nextThresholdIndex: this.getNextThresholdIndex(this.totalPrice),
            },
          })
        );
      }

      getThresholdIndex(totalPrice) {
        let lastIndex = null;
        this.thresholds.forEach((threshold, index) => {
          if (totalPrice >= threshold) lastIndex = index;
        });
        if (this.progressType !== 'progress_step_price') {
          lastIndex = this.productsCount;
        }
        return lastIndex;
      }

      getNextThresholdIndex(totalPrice) {
        let lastIndex = -1;
        this.thresholds.forEach((threshold, index) => {
          if (totalPrice >= threshold) lastIndex = index;
        });
        if (this.progressType !== 'progress_step_price') {
          return this.productsCount + 1;
        }
        return lastIndex + 1;
      }

      updatePrices(data) {
        let totalPrice = data.effectiveTotalPrice != null ? data.effectiveTotalPrice : data.totalPrice;
        if (this.progressType === 'progress_step_price' && data.thresholdIndex !== null) {
          this.querySelector('.pack-builder-summary--compare').innerHTML = formatPrice(totalPrice);
          totalPrice -= this.discounts[data.thresholdIndex];
        } else {
          this.querySelector('.pack-builder-summary--compare').innerHTML = '';
        }
        const finalTotalPrice = Math.max(totalPrice, 0);
        this.querySelector('.pack-builder-summary--price').innerHTML = formatPrice(finalTotalPrice);
        this.updateAddButtonPrice(finalTotalPrice);
      }

      updateAddButtonPrice(totalPrice) {
        if (!this.addButtonPrice) return;
        if (this.productsCount > 0 && totalPrice > 0) {
          this.addButtonPrice.textContent = formatPrice(totalPrice);
          this.addButtonPrice.classList.remove('hidden');
        } else {
          this.addButtonPrice.textContent = '';
          this.addButtonPrice.classList.add('hidden');
        }
      }

      updateSummaryText(data) {
        if (this.progressType === 'progress_step_price') {
          const amountNeededSpan = this.querySelector('.pack-builder-summary--text-amount-needed');
          const discountSpan = this.querySelector('.pack-builder-summary--text-discount');
          if (data.nextThresholdIndex < this.thresholds.length) {
            amountNeededSpan.innerHTML = formatPrice(this.thresholds[data.nextThresholdIndex] - data.totalPrice);
            discountSpan.innerHTML = formatPrice(this.discounts[data.nextThresholdIndex]);
          }
        }

        if (this.progressType === 'progress_step_price' && data.nextThresholdIndex === this.thresholds.length) {
          this.querySelector('.pack-builder-summary--success-text').classList.remove('hidden');
          this.querySelector('.pack-builder-summary--text').classList.add('hidden');
          this.querySelector('.pack-builder-summary--disabled-text').classList.add('hidden');
        } else if (this.productsCount < this.minProduct) {
          this.querySelector('.pack-builder-summary--success-text').classList.add('hidden');
          this.querySelector('.pack-builder-summary--disabled-text').classList.remove('hidden');
          this.querySelector('.pack-builder-summary--text').classList.add('hidden');
        } else {
          this.querySelector('.pack-builder-summary--success-text').classList.add('hidden');
          this.querySelector('.pack-builder-summary--disabled-text').classList.add('hidden');
          this.querySelector('.pack-builder-summary--text').classList.remove('hidden');
        }
      }

      updateFormInputs() {
        this.resetMainFormInputs();
        const items = Array.from(this.querySelectorAll('.pack-builder-summary--product-list--item'));
        items.forEach((item, index) => {
          const inputId = document.createElement('input');
          inputId.type = 'hidden';
          inputId.name = `items[${index}][id]`;
          inputId.value = item.dataset.id;

          const inputQuantity = document.createElement('input');
          inputQuantity.type = 'hidden';
          inputQuantity.name = `items[${index}][quantity]`;
          inputQuantity.value = Math.max(1, parseInt(item.dataset.quantity, 10) || 1);

          this.form.querySelector('.pack-builder-summary--form--inputs').appendChild(inputId);
          this.form.querySelector('.pack-builder-summary--form--inputs').appendChild(inputQuantity);
        });
      }

      resetMainFormInputs() {
        this.form.querySelector('.pack-builder-summary--form--inputs').innerHTML = '';
      }

      getDisplayAmount(baseAmount) {
        if (this.purchaseType !== 'subscription') return baseAmount;
        return Math.round(baseAmount * (1 - this.subscriptionDiscountPercent / 100));
      }

      refreshItemPrices() {
        const items = Array.from(this.querySelectorAll('.pack-builder-summary--product-list--item'));
        items.forEach((item) => {
          this.updateSummaryItemPrice(item);
        });
      }

      updateSummaryItemPrice(item) {
        const basePrice = parseFloat(item.dataset.price) * parseInt(item.dataset.quantity, 10);
        const displayPrice = this.getDisplayAmount(basePrice);
        const priceNode = item.querySelector('.pack-builder-summary--product-list--item--price');
        const compareNode = item.querySelector('.pack-builder-summary--product-list--item--compare-at-price');
        const discountNote = item.querySelector('.pack-builder-summary--product-list--item--discount-note');
        if (priceNode) {
          priceNode.innerHTML = formatPrice(displayPrice);
        }
        if (compareNode) {
          if (this.purchaseType === 'subscription') {
            compareNode.innerHTML = formatPrice(basePrice);
            compareNode.classList.remove('hidden');
          } else {
            compareNode.innerHTML = '';
            compareNode.classList.add('hidden');
          }
        }
        if (discountNote) {
          discountNote.classList.toggle('hidden', this.purchaseType !== 'subscription');
        }
      }

      syncVariantQuantityToSessionStorage(variantId, quantity) {
        const savedVariants = JSON.parse(sessionStorage.getItem('packBuilderSelectedVariants') || '[]');
        const index = savedVariants.findIndex((variant) => String(variant.id) === String(variantId));
        if (index === -1) return;
        if (quantity <= 0) {
          savedVariants.splice(index, 1);
        } else {
          savedVariants[index].quantity = quantity;
        }
        sessionStorage.setItem('packBuilderSelectedVariants', JSON.stringify(savedVariants));
      }

      syncVariantSellingPlanToSessionStorage(variantId, sellingPlanId) {
        const savedVariants = JSON.parse(sessionStorage.getItem('packBuilderSelectedVariants') || '[]');
        const index = savedVariants.findIndex((variant) => String(variant.id) === String(variantId));
        if (index === -1) return;
        savedVariants[index].selected_selling_plan_id = sellingPlanId || '';
        sessionStorage.setItem('packBuilderSelectedVariants', JSON.stringify(savedVariants));
      }

      getVariantSellingPlans(variant) {
        if (!variant) return [];
        if (Array.isArray(variant.pack_builder_selling_plans) && variant.pack_builder_selling_plans.length) {
          return variant.pack_builder_selling_plans;
        }
        if (!Array.isArray(variant.selling_plan_allocations)) return [];
        return variant.selling_plan_allocations
          .map((allocation, index) => {
            if (!allocation || !allocation.selling_plan_id) return null;
            return {
              id: allocation.selling_plan_id,
              name: `Livraison ${index + 1}`,
            };
          })
          .filter(Boolean);
      }

      resolveDefaultSellingPlanId(plans, preferredId) {
        if (!Array.isArray(plans) || !plans.length) return '';
        if (preferredId && plans.find((plan) => String(plan.id) === String(preferredId))) {
          return preferredId;
        }
        const planOneMonth = plans.find((plan) => /1\s*mois|tous?\s*les?\s*mois|monthly|every\s*month/i.test(String(plan.name)));
        return String((planOneMonth || plans[0]).id);
      }

      updateSellingPlanInputsState() {
        const isSubscription = this.purchaseType === 'subscription';
        this.querySelectorAll('.pack-builder-summary--selling-plan').forEach((container) => {
          container.classList.toggle('hidden', !isSubscription);
        });
      }

      escapeHtml(value) {
        const div = document.createElement('div');
        div.textContent = value == null ? '' : String(value);
        return div.innerHTML;
      }

      increaseItemQuantity(variantId) {
        const item = this.summaryProductList.querySelector(`.pack-builder-summary--product-list--item[data-id="${variantId}"]`);
        if (!item) return;
        const qty = parseInt(item.dataset.quantity, 10) || 1;
        const nextQty = qty + 1;
        item.dataset.quantity = nextQty;
        const qtyBadge = item.querySelector('.pack-builder-summary--product-list--item--quantity');
        const qtyValue = item.querySelector('.pack-builder-summary--product-list--item--quantity-value');
        if (qtyBadge) qtyBadge.innerHTML = nextQty;
        if (qtyValue) qtyValue.innerHTML = nextQty;
        this.updateSummaryItemPrice(item);
        this.syncVariantQuantityToSessionStorage(variantId, nextQty);
        this.updateFormInputs();
        this.increaseProductCount();
      }

      decreaseItemQuantity(variantId, crosssell = null) {
        const item = this.summaryProductList.querySelector(`.pack-builder-summary--product-list--item[data-id="${variantId}"]`);
        if (!item) return;
        const qty = parseInt(item.dataset.quantity, 10) || 1;
        if (qty <= 1) {
          this.removeItem(variantId);
          if (crosssell != null) {
            crosssell.querySelector('.deployer-switch input').checked = false;
            crosssell.classList.remove('toggle-cross-sell__product--active');
          }
          return;
        }
        const nextQty = qty - 1;
        item.dataset.quantity = nextQty;
        const qtyBadge = item.querySelector('.pack-builder-summary--product-list--item--quantity');
        const qtyValue = item.querySelector('.pack-builder-summary--product-list--item--quantity-value');
        if (qtyBadge) qtyBadge.innerHTML = nextQty;
        if (qtyValue) qtyValue.innerHTML = nextQty;
        this.updateSummaryItemPrice(item);
        this.syncVariantQuantityToSessionStorage(variantId, nextQty);
        this.updateFormInputs();
        this.decreaseProductCount(1);
        this.getTotalPrice();
        this.syncCrossSellStates();
        this.renderMobilePreview();
      }

      toggleMobileSummary() {
        if (!window.matchMedia('(max-width: 799px)').matches) return;
        if (this.classList.contains('pack-builder-summary--mobile-expanded')) return;
        this.classList.add('pack-builder-summary--mobile-expanded');
        document.body.classList.add('pack-builder-summary-mobile-open');
        if (this.mobileToggle) {
          this.mobileToggle.setAttribute('aria-expanded', 'true');
        }
      }

      closeMobileSummary() {
        this.classList.remove('pack-builder-summary--mobile-expanded');
        document.body.classList.remove('pack-builder-summary-mobile-open');
        if (this.mobileToggle) {
          this.mobileToggle.setAttribute('aria-expanded', 'false');
        }
      }

      handleViewportChange() {
        const isMobile = window.matchMedia('(max-width: 799px)').matches;
        if (!isMobile) {
          this.classList.remove('pack-builder-summary--mobile-expanded');
          document.body.classList.remove('pack-builder-summary-mobile-open');
          if (this.mobileToggle) {
            this.mobileToggle.setAttribute('aria-expanded', 'false');
          }
          return;
        }
        if (this.mobileToggle) {
          const expanded = this.classList.contains('pack-builder-summary--mobile-expanded');
          document.body.classList.toggle('pack-builder-summary-mobile-open', expanded);
          this.mobileToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
      }

      renderMobilePreview() {
        if (!this.mobileProducts) return;
        const items = Array.from(this.querySelectorAll('.pack-builder-summary--product-list--item'));
        const slots = items.slice(0, this.mobilePreviewSlots);
        const emptySlotsCount = Math.max(0, this.mobilePreviewSlots - slots.length);

        let html = '';
        slots.forEach((item) => {
          const image = item.querySelector('.pack-builder-summary--product-list--item--image img');
          if (image && image.getAttribute('src')) {
            html += `<div class="pack-builder-summary__mobile-slot"><img src="${image.getAttribute('src')}" alt="" loading="lazy" /></div>`;
          } else {
            html += '<div class="pack-builder-summary__mobile-slot pack-builder-summary__mobile-slot--empty"></div>';
          }
        });

        for (let index = 0; index < emptySlotsCount; index += 1) {
          html += '<div class="pack-builder-summary__mobile-slot pack-builder-summary__mobile-slot--empty"></div>';
        }

        this.mobileProducts.innerHTML = html;
      }

      syncCrossSellStates() {
        const crossSell = this.closest('.deployer-pack-builder-section').querySelector('pack-builder-toggle-cross-sell');
        if (crossSell && typeof crossSell.syncStateWithSummary === 'function') {
          crossSell.syncStateWithSummary();
        }
      }
    }
  );
}

if (!customElements.get('pack-builder-toggle-cross-sell')) {
  customElements.define(
    'pack-builder-toggle-cross-sell',
    class PackBuilderToggleCrossSell extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
          const label = product.querySelector('.deployer-switch--label');
          if (label) {
            label.addEventListener('click', (event) => {
              if (event.target.tagName !== 'INPUT') {
                this.onToggleProduct(event, product);
              }
            });
          }

          const select = product.querySelector('.deployer-select');
          if (select) {
            select.addEventListener('change', (event) => this.variantChanged(event, product));
          }
        });
        this.syncStateWithSummary();
      }

      async onToggleProduct(event, productElement) {
        event.preventDefault();
        const checkbox = productElement.querySelector('input[type="checkbox"]');
        if (!checkbox) return;

        if (!checkbox.checked) {
          this.setProductAddedState(productElement, true);
          const variantData = await this.closest('.deployer-pack-builder-section')
            .querySelector('deployer-pack-builder')
            .getVariantData(checkbox.dataset.productHandle, checkbox.dataset.variantId);

          this.closest('.deployer-pack-builder-section').querySelector('pack-builder-summary').createVariantItem(variantData, productElement);
          this.closest('.deployer-pack-builder-section').querySelector('pack-builder-summary').increaseProductCount();
        } else {
          this.setProductAddedState(productElement, false);
          this.closest('.deployer-pack-builder-section').querySelector('pack-builder-summary').removeItem(checkbox.dataset.variantId);
        }
      }

      variantChanged(event, product) {
        const select = product.querySelector('.deployer-select');
        const optionSelected = select.options[select.selectedIndex];
        this.updateProductPrice(product, optionSelected);
        this.updateProductImage(product, optionSelected);
        this.updateVariantId(product, optionSelected, event);
      }

      updateProductPrice(product, optionSelected) {
        product.querySelector('.toggle-cross-sell__product-price').innerHTML = optionSelected.dataset.price;
        const compare = product.querySelector('.toggle-cross-sell__product-compare-at-price');
        if (compare && optionSelected.dataset.compareAtPrice) {
          compare.innerHTML = optionSelected.dataset.compareAtPrice;
          compare.style.display = 'inline';
        } else if (compare) {
          compare.style.display = 'none';
        }
      }

      updateProductImage(product, optionSelected) {
        const image = product.querySelector('.toggle-cross-sell__product-image img');
        if (image && optionSelected.dataset.variantImage) {
          image.src = optionSelected.dataset.variantImage;
        }
      }

      updateVariantId(product, optionSelected, event) {
        const variantId = optionSelected.value;
        const checkbox = product.querySelector('.deployer-switch input');
        checkbox.dataset.variantId = variantId;
        if (!checkbox.checked) {
          this.onToggleProduct(event, product);
        }
      }

      setProductAddedState(product, isAdded) {
        const checkbox = product.querySelector('.deployer-switch input');
        const switchLabel = product.querySelector('.deployer-switch--label');
        if (checkbox) checkbox.checked = isAdded;
        product.classList.toggle('toggle-cross-sell__product--active', isAdded);
        product.classList.toggle('hidden', isAdded);
        if (switchLabel) switchLabel.classList.remove('hidden');
      }

      syncStateWithSummary() {
        const summary = this.closest('.deployer-pack-builder-section').querySelector('pack-builder-summary');
        if (!summary) return;
        let visibleProductsCount = 0;
        this.querySelectorAll('.toggle-cross-sell__product').forEach((product) => {
          const checkbox = product.querySelector('.deployer-switch input');
          if (!checkbox) return;
          const isAdded = !!summary.querySelector(`.pack-builder-summary--product-list--item[data-id="${checkbox.dataset.variantId}"]`);
          this.setProductAddedState(product, isAdded);
          if (!isAdded) visibleProductsCount += 1;
        });
        this.classList.toggle('hidden', visibleProductsCount === 0);
      }
    }
  );
}

